<template lang="">
  <div>
    <pbi-report ref="dashboard" height="100vh" width="100%" />
  </div>
</template>
<script>
import PbiReport from "@/components/common/PowerBiReport";
import dashbordApi from "@/services/api/dashbord.api";
import DashboarReports from "@/utils/constants/dashboarReports";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";

export default {
  name: "Dashboard",
  components: {
    PbiReport
  },
  mixins: [alertMixin],
  props: {
    inventoryCatalogId: {
      type: Number,
      required: true
    }
  },
  data: () => ({}),
  async mounted() {
    await this.getReportData();
  },
  methods: {
    async getReportData() {
      try {
        const params = {
          inventoryCatalogId: this.inventoryCatalogId
        };
        const { data } = await dashbordApi.getDashbord(
          DashboarReports.DashboardInventarioBooks,
          params
        );
        this.$refs["dashboard"].render(
          data.id,
          data.embedToken.token,
          data.embedUrl,
          data.filterParameters
        );
      } catch (error) {
        this.ShowToast("Alerta", error?.response?.data?.message, "error");
      }
    }
  }
};
</script>
<style lang="scss"></style>
